import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  headerWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'wrap',
    margin: '10px 40px 24px'
  },
  cardWrapper: {
    margin: '10px 40px 24px',
    padding: '20px'
  },
  title: {
    color: '#335977',
    fontWeight: 'bold',
    fontSize: '38px',
  },
  subTitle: {
    fontSize: '16px',
    color: '#545455',
    marginTop: '10px'
  },
  buttons: {
    margin: '5px 10px',
    minWidth: '200px',
    width: 'auto'
  },
  apiKeyBox: {
    backgroundColor: '#F7F7F7',
    padding: '8px',
    marginBottom: '15px'
  },
  apiKey: {
    color: '#545455',
    fontWeight: 'bold',
    fontSize: '14px',
    marginRight: '2px'
  },
  apiKeyValue: {
    color: '#545455',
    fontSize: '14px',
    marginRight: '10px',
    wordBreak: 'break-all'
  },
  paper: {
    maxHeight: '200px',
    overflowY: 'auto',
    minWidth: '200px',

    '&::-webkit-scrollbar': {
      width: '5px'
    },

    '&::-webkit-scrollbar-thumb': {
      borderRadius: '3px',
      backgroundColor: '#c3c3c3',
      width: '5px'
    }
  },
  paperText: {
    textTransform: 'none',
    wordBreak: 'break-all',
    fontWeight: 500
  },
  tableIcons: {
    cursor: 'pointer'
  },
  selectMessageWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '300px',
    color: '#F37320',
    fontSize: '20px',
    fontWeight: '600',
    textAlign: 'center'
  },
  deleteModalText: {
    fontSize: '15px',
    color: '#393939'
  },
  deleteModalButton: {
    maxWidth: 180
  },
  tableClientName: {
    width: '350px',
    whiteSpace: 'nowrap'
  },
  tableClientId: {
    width: '300px',
  },
  tableClientSecret: {
    width: '550px',
    wordBreak: 'break-word'
  },
  tableProgramId: {
    width: '300px',
    wordBreak: 'break-word'
  },
  tableActions: {
    textAlign: 'center'
  },
  infoPopover: {
    color: '#4A4A4A',
    fontSize: '14px',
    opacity: '70%',
    textAlign: 'left',
  },
  infoPopoverPaper: {
    width: '250px'
  },
  hideCard: {
    display: 'none'
  }
}))

export { useStyles }